module.exports = "./dist/exit.svg?b58af00ca13b2ec6a21b4c7ec4ae7db7";


//////////////////
// WEBPACK FOOTER
// ./src/img/exit.svg
// module id = 67
// module chunks = 0